module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei4.svg";